import type { Point } from "./geometry";

export interface NavigationRect {
  left: number;
  right: number;
  top: number;
  bottom: number;
}

export function navigationSafeRect(
  width: number,
  height: number,
  tutorialGuidanceVisible = false,
): NavigationRect {
  const portrait = width <= 650 && height > width;
  const compact = width <= 900 || height <= 500;
  const left = portrait ? 35 : compact ? 180 : 220;
  const right = portrait ? 35 : compact ? 225 : 270;
  const top = tutorialGuidanceVisible
    ? portrait ? 220 : compact ? 136 : 152
    : portrait ? 150 : 60;
  const bottom = portrait ? 285 : compact ? 130 : 180;
  return {
    left: Math.min(left, width * 0.28),
    right: width - right,
    top: Math.min(top, height / 2 - 40),
    bottom: Math.max(height - bottom, height / 2 + 40),
  };
}

export function navigationArrow(
  point: Point,
  width: number,
  height: number,
  rect: NavigationRect,
): Point & { angle: number } {
  const angle = Math.atan2(point.y - height / 2, point.x - width / 2);
  const dx = Math.cos(angle);
  const dy = Math.sin(angle);
  const left = rect.left + 12;
  const right = rect.right - 12;
  const top = rect.top + 12;
  const bottom = rect.bottom - 12;
  const originX = Math.max(left, Math.min(right, width / 2));
  const originY = Math.max(top, Math.min(bottom, height / 2));
  const distanceX =
    Math.abs(dx) < 0.001
      ? Infinity
      : (dx > 0 ? right - originX : left - originX) / dx;
  const distanceY =
    Math.abs(dy) < 0.001
      ? Infinity
      : (dy > 0 ? bottom - originY : top - originY) / dy;
  const distance = Math.min(distanceX, distanceY);
  return { x: originX + dx * distance, y: originY + dy * distance, angle };
}
